module.exports = __webpack_public_path__ + "static/media/Color_Drug_Logo_v01.a2b6c919.png";